import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import AnimatedComponent from "../../../Components/AnimatedComponent";
import { fadeInY } from "../../../utils/animatedVariants";
import bgimage from '../../../assets/images/layout/PHRFBYB-2.png'
import T52GYVU from '../../../assets/images/layout/YE2ARQM-min.png'
import Accordion from './components/AccordionFAQ';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { toast, } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import BeatLoader from '../../../common/Loader/BeatLoader';
import { useNetworkError } from '../../../hooks/context/NetworkErrorContext';
import { getEnvVar } from "../../../config/env-config";

function Faq() {
    const { t } = useTranslation();
    const [faqDetails, setFaqDetails] = useState([]);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();
    const location = useLocation();
    var currentPath = location.pathname + location.search;
    const { setInternetError } = useNetworkError(); // Using the context

    // Get FAQ details
    const getFaqDetails = () => {
        axios.post((getEnvVar('REACT_APP_USER_PUBLIC_URL') || '') + 'api/public/' + "faq",
            {
                "limit": 100000000,
                "page": 1,
                "globalSearch": ""
            },
            {
                "Content-Type": "multipart/form-data",
                headers: {
                    // "api-token": "68481d08a799ad6967f57263",
                },
            }).then((response) => {
                if (response.data) {
                    if (response.data.code === 200) {
                        setFaqDetails(response.data.data.faqs);
                    } else if (response.data.code === 500) {
                        toast.error(response.data.message);
                    } else if (response.data.code === 404) {
                        toast.error(response.data.message);
                    } else if (response.data.code === 503) {
                        window.location.href = `/maintenece_mode?redirect=${encodeURIComponent(currentPath)}`;
                    } else {
                        toast.error(response.data.message, { autoClose: 5000 });
                    }
                }
            }).catch((error) => {
                console.error("API Error:", error);

                if (!error.response) {
                    // Network/connection/server error
                    setInternetError(true);
                } else {
                    setInternetError(false);
                }

                toast.error("Failed to load booking details.");
            }).finally(() => {
                setTimeout(() => {
                    setLoading(false);
                }, 2000);
            });
    }

    // Get FAQ details
    useEffect(() => {
        getFaqDetails();
    }, []);

    return (
        <>
            {
                loading ? (
                    // Display the BeatLoader while loading
                    <div className="flex items-center justify-center absolute h-full z-50 w-full bg-[#021a35f2]" >
                        <BeatLoader loading={loading} />
                    </div>
                ) : (
                    <>
                        <section
                            className={'h-full w-full py-16  3xl:px-32 2xl:px-32 lg:px-16 px-6 bg-cover relative'}
                            style={{ backgroundImage: `url(${bgimage})` }}
                        >
                            <div className={'absolute bg-[#051b34e0] inset-0 bg-violet-500/90 z-3'}></div>
                            <div className="pt-24 pb-20 relative z-10">
                                <h1 className="text-white text-[38px] font-semibold">{t('main.FAQ.Users_FAQs')}</h1>
                                <p className="text-gray-400 text-[20px]">{t('main.FAQ.Have_Any_Question_Title')}</p>
                            </div>
                        </section>

                        {/* FAQ Section */}
                        <div className={'w-full py-16 xl-max:pt-0 xl-max:pb-6 3xl:px-32 2xl:px-32 lg:px-16 px-6 bg-[#fafafa]'}>
                            <div className={'items-start  h-full grid grid-cols-1 3xl:grid-cols-2 2xl:grid-cols-2  xl:grid-cols-2 gap-24 xl-max:gap-0 text-left'}>

                                <div className={'text-left'}>
                                    <AnimatedComponent
                                        tag="div"
                                    >
                                        <AnimatedComponent tag="div" variants={fadeInY(0.8)} className="">
                                            <h2 className="Heading-02 lg:text-[35px]  w-full  my-2 mb-3">
                                                {t('main.FAQ.Frequently_Asked')}
                                                <strong>{t('main.FAQ.Questions')}</strong>
                                            </h2>

                                            <p className={'paragraph'}>
                                                {t('main.FAQ.Main_Title')}
                                            </p>

                                            <div className={'mt-3 xl-max:mt-6'}>
                                                <AnimatedComponent
                                                    tag="img"
                                                    src={T52GYVU}
                                                    alt={''}
                                                    className={'rounded-[5px] w-full'}
                                                />
                                            </div>
                                        </AnimatedComponent>
                                    </AnimatedComponent>
                                </div>
                                <div className={'lg-max:order-last'}>
                                    <div className={' mb-10 text-left w-full bg-white  rounded-xl duration-500 '}>
                                        <div className={'py-3 w-full text-left'}>
                                            {
                                                faqDetails.length > 0 ?
                                                    <>
                                                        <div className={'w-full mb-3 py-2 px-3'}>
                                                            <h6 className={'fearure-head'}>{t('main.FAQ.Global_Questions')}</h6>
                                                        </div>
                                                        <Accordion faqDetails={faqDetails} />
                                                    </> :
                                                    <div className='h-screen items-center px-8 py-10 flex justify-center mx-auto w-full bg-white shadow-md rounded-xl duration-500 hover:scale-105 hover:shadow-xl'>
                                                        <h3 className='font-bold text-[18px] text-yellow-600'>{t('main.FAQ.No_Faq_Available')}</h3>
                                                    </div>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                )
            }
        </>
    )
}

export default Faq